import { ca } from '@cian/analytics';
import { TDevice } from '@cian/utils';

import { getSiteType } from '../../utils/analytics';

export function trackShowBanner(queryString: string, deviceType: TDevice, label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Map',
    action: 'show_sopr',
    label,
    page: {
      pageType: 'Map',
      siteType: getSiteType(deviceType),
      queryString,
    },
  });
}

export function trackClickBanner(queryString: string, deviceType: TDevice, label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Map',
    action: 'Click',
    label,
    page: {
      pageType: 'Map',
      siteType: getSiteType(deviceType),
      queryString,
    },
  });
}

export function trackCloseBanner(queryString: string, deviceType: TDevice, label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Map',
    action: 'Close',
    label,
    page: {
      pageType: 'Map',
      siteType: getSiteType(deviceType),
      queryString,
    },
  });
}
